if (!customElements.get('product-specs')) {
  customElements.define(
    'product-specs',
    class ProductSpecs extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        if (typeof subscribe !== 'function') return;
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (!event || !event.data || event.data.sectionId !== this.sectionId) return;

          const id = `ProductSpecs-${this.sectionId}`;
          const source = event.data.html.getElementById(id);
          const dest = document.getElementById(id);
          if (source && dest) dest.innerHTML = source.innerHTML;

          // Hide the whole block when the newly selected variant has no specs.
          const hasSpecs = source && source.innerHTML.trim() !== '';
          this.classList.toggle('hidden', !hasSpecs);
        });
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }
    }
  );
}
